import axios from '@/http/index';

const base = '';
// 获取首页当天收入信息
export const getIndexMsg = (params) => axios.get(`${base}/erp/home/getHomeMsg`, params).then((res) => res.data);
// 登录获取店铺
export const getSignSuccess = (param) => axios.get(`${base}/erp/login/loginSuccess`, param).then((res) => res.data);
// 获得员工当前值班状态信息
export const getVacationListByStatus = (param) => axios.get(`${base}/erp/vacation/getVacationListByStatus`, param).then((res) => res.data);
